import type {
  InventoryItem,
  ModifiedData,
} from 'app/components/pages/Extranet/ExtranetInventory/Modern/InventoryStore';
import {
  deriveEditedFieldsFromRoomData,
  isBarOnlyEdit,
} from 'app/components/pages/Extranet/ExtranetInventory/Modern/utils/editedFields';
import type { EditedRoomFields } from 'app/components/pages/Extranet/ExtranetInventory/Modern/utils/editedFields';
import type {
  InventoryDateRooms,
  InventoryRoomsForm,
} from 'app/typings/core/extranet/inventory/form/inventoryForm';
import type { UpdateRoomInventory } from 'app/typings/core/extranet/inventory/form/roomForm';

const parseNumber = (value: unknown): number | undefined => {
  const parsed = typeof value === 'number' ? value : Number(value);

  return Number.isNaN(parsed) ? undefined : parsed;
};

export const mapToRoomResponse = (
  rooms: ModifiedData,
  editedRoomFields: EditedRoomFields = {}
): InventoryRoomsForm => {
  const result: InventoryRoomsForm = {};

  Object.entries(rooms || {}).forEach(([dateKey, items]) => {
    if (!items || typeof items !== 'object') {
      return;
    }

    const dateEntry: InventoryDateRooms = {
      rooms: {},
    };

    Object.entries(items).forEach(([itemId, itemData]) => {
      if (!itemData || typeof itemData !== 'object') {
        return;
      }

      const item = itemData as InventoryItem;
      const roomData: Omit<UpdateRoomInventory, 'editedFields'> = {};
      const editedFields = editedRoomFields[dateKey]?.[Number(itemId)];

      const remainingStock = parseNumber(item.remainingStock);

      if (remainingStock !== undefined) {
        roomData.remainingStock = remainingStock;
      }

      const price = parseNumber(item.price);

      if (price !== undefined) {
        roomData.price = price;
      }

      const discountPrice = parseNumber(item.discountPrice);

      if (discountPrice !== undefined && !isBarOnlyEdit(editedFields)) {
        roomData.discountPrice = discountPrice;
      }

      if (item.isClosedByHotel !== undefined && item.isClosedByHotel !== null) {
        roomData.isClosedByHotel = Boolean(item.isClosedByHotel);
      }

      if (
        item.isClosedByStaycation !== undefined &&
        item.isClosedByStaycation !== null
      ) {
        roomData.isClosedByStaycation = Boolean(item.isClosedByStaycation);
      }

      if (Object.keys(roomData).length > 0) {
        const editedFieldsToSend =
          editedFields && editedFields.length > 0
            ? editedFields
            : deriveEditedFieldsFromRoomData(roomData);

        dateEntry.rooms[Number(itemId)] = {
          ...roomData,
          editedFields: editedFieldsToSend,
        };
      }
    });

    if (Object.keys(dateEntry.rooms).length > 0) {
      result[dateKey] = dateEntry;
    }
  });

  return result;
};
